import { useTheme } from '@/hooks/useTheme';

interface AiobiLogoProps {
  size?: number;
  variant?: 'auto' | 'light' | 'dark' | 'full';
  className?: string;
}

const SOURCES = {
  light: '/logos/logo_aiobi.png',
  dark: '/logos/logo_aiobi_branco.png',
  full: '/logos/full_logo_aiobi.png',
} as const;

/**
 * Logo AIOBI. Por defeito segue o tema actual:
 *  - light → logo_aiobi.png (azul institucional)
 *  - dark  → logo_aiobi_branco.png (branco)
 *  - full  → full_logo_aiobi.png (lockup horizontal completo, para PDF/print)
 */
export function AiobiLogo({ size = 32, variant = 'auto', className }: AiobiLogoProps) {
  const { resolved } = useTheme();
  const src =
    variant === 'auto'
      ? resolved === 'dark'
        ? SOURCES.dark
        : SOURCES.light
      : SOURCES[variant];

  return (
    <img
      src={src}
      alt="AIOBI"
      height={size}
      className={['aiobi-logo-img', className].filter(Boolean).join(' ')}
      style={{ height: size }}
    />
  );
}
